/* Valerie theme scripts. No dependencies. */
(function () {
  'use strict';

  var cfg = window.valerie || { routes: {} };

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas.split('.')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  /* ---------- Drawers (menu, filters, size guide) ---------- */
  var lastFocus = null;
  function openDrawer(id, trigger) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocus = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var focusable = drawer.querySelector('button, a, input, select, textarea');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-drawer');
    document.querySelectorAll('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open'), opener); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer && closer.type !== 'submit') { var d = closer.closest('.drawer'); if (d) closeDrawer(d); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.drawer.is-open');
    if (open) closeDrawer(open);
    var lb = document.querySelector('.lightbox.is-open');
    if (lb) closeLightbox(lb);
  });

  /* ---------- Cart count and toast ---------- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
  var toastTimer;
  function toast(message) {
    var el = document.getElementById('CartToast');
    if (!el) return;
    el.querySelector('[data-toast-message]').textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 5000);
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var dataEl = document.querySelector('[data-product-json]');
    var form = document.getElementById('ProductForm');
    if (!dataEl || !form) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    // Shopify only hands the page the first 250 variants. Bigger products (print bras) look the rest up.
    var truncated = (data.variants_count || 0) > variants.length;
    var pending = null;
    try {
      var cur = JSON.parse(document.querySelector('[data-current-variant]').textContent);
      if (cur && cur.id && !variants.some(function (v) { return v.id === cur.id; })) variants.push(cur);
    } catch (e) {}
    function sameOptions(a, b) { return a.length === b.length && a.every(function (o, i) { return o === b[i]; }); }
    function resolveVariant(sel) {
      var ids = fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c && c.getAttribute('data-value-id'); });
      if (ids.indexOf(null) !== -1 || !data.url) return Promise.resolve(null);
      return fetch(data.url + '?option_values=' + ids.join(',') + '&section_id=' + encodeURIComponent(data.section_id))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-current-variant]');
          var v = el && JSON.parse(el.textContent);
          return v && sameOptions(v.options, sel) ? v : null;
        })
        .catch(function () { return null; });
    }
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var errorEl = form.querySelector('[data-form-error]');
    var fieldsets = Array.prototype.slice.call(form.querySelectorAll('fieldset[data-option-index]'));
    var priceEl = root.querySelector('[data-product-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    function selected() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function findVariant(sel) {
      if (sel.indexOf(null) !== -1) return null;
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      }) || null;
    }

    // Grey out values that can't be bought with the other current choices
    function markAvailability(sel) {
      if (truncated) {
        form.querySelectorAll('.chip.is-unavailable').forEach(function (c) { c.classList.remove('is-unavailable'); });
        return;
      }
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (input) {
          var val = input.value;
          var ok = variants.some(function (v) {
            if (!v.available || v.options[idx] !== val) return false;
            return v.options.every(function (o, j) { return j === idx || sel[j] === null || o === sel[j]; });
          });
          input.closest('.chip').classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function priceHtml(v) {
      var html = '';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<s><span class="visually-hidden">Was </span>' + formatMoney(v.compare_at_price) + '</s> <span class="visually-hidden">Now </span>';
      }
      return '<span class="price">' + html + formatMoney(v.price) + '</span>';
    }

    function moveToMedia(mediaId) {
      if (!mediaId) return;
      var gallery = root.querySelector('[data-gallery]');
      var item = gallery && gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (!item) return;
      if (window.matchMedia('(max-width: 899px)').matches) {
        gallery.scrollTo({ left: item.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      } else if (gallery.firstElementChild !== item) {
        gallery.insertBefore(item, gallery.firstElementChild);
      }
    }

    function update() {
      var sel = selected();
      var v = findVariant(sel);
      markAvailability(sel);
      fieldsets.forEach(function (fs, i) {
        var label = fs.querySelector('[data-selected-value]');
        if (label) label.textContent = sel[i] || '';
        if (sel[i]) fs.querySelector('[data-option-error]').hidden = true;
      });
      errorEl.hidden = true;
      if (v) {
        idInput.value = v.id;
        idInput.removeAttribute('data-needs-choice');
        if (priceEl) priceEl.innerHTML = priceHtml(v);
        if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
        addBtn.disabled = !v.available;
        addLabel.textContent = v.available ? 'Add to bag' : 'Unavailable';
        moveToMedia(v.featured_media);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } else {
        idInput.setAttribute('data-needs-choice', '');
        addBtn.disabled = false;
        addLabel.textContent = 'Add to bag';
        if (truncated && sel.indexOf(null) === -1) {
          pending = resolveVariant(sel).then(function (found) {
            pending = null;
            if (found && sameOptions(selected(), found.options)) { variants.push(found); update(); }
          });
        }
        // Colour can change the image even before a size is chosen
        var colourIdx = fieldsets.findIndex(function (fs) { return fs.classList.contains('option--swatch'); });
        if (colourIdx > -1 && sel[colourIdx]) {
          var match = variants.find(function (x) { return x.options[colourIdx] === sel[colourIdx] && x.featured_media; });
          if (match) moveToMedia(match.featured_media);
        }
      }
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });

    // Band size (line item property) for bras without a band option
    var bandFs = form.querySelector('[data-band-property]');
    function bandValue() { var c = bandFs && bandFs.querySelector('input:checked'); return c ? c.value : null; }
    if (bandFs) {
      bandFs.addEventListener('change', function () {
        bandFs.querySelector('[data-selected-value]').textContent = bandValue() || '';
        bandFs.querySelector('[data-option-error]').hidden = true;
      });
    }
    if (fieldsets.length) markAvailability(selected());

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var sel = selected();
      var missing = fieldsets.filter(function (fs, i) { return !sel[i]; });
      if (bandFs && !bandValue()) missing.push(bandFs);
      if (missing.length) {
        missing.forEach(function (fs) { fs.querySelector('[data-option-error]').hidden = false; });
        missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = missing[0].querySelector('input');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 300);
        return;
      }
      if (pending) {
        addBtn.classList.add('is-loading');
        pending.then(function () { addBtn.classList.remove('is-loading'); form.requestSubmit ? form.requestSubmit() : addBtn.click(); });
        return;
      }
      if (idInput.hasAttribute('data-needs-choice')) {
        errorEl.textContent = 'Sorry, that combination isn\'t available. Please try another, or message us and we\'ll sort it.';
        errorEl.hidden = false;
        return;
      }
      addBtn.classList.add('is-loading');
      addBtn.setAttribute('aria-busy', 'true');
      fetch((cfg.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Something went wrong. Please try again.');
          return fetch((cfg.routes.cart_url || '/cart') + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          setCartCount(cart.item_count);
          var parts = sel.map(function (v, i) {
            if (v && bandValue() && fieldsets[i].getAttribute('data-option-name').toLowerCase().indexOf('cup') > -1) return bandValue() + ' ' + v;
            return v;
          });
          var opts = parts.filter(Boolean).join(', ');
          toast(data.title + (opts ? ' (' + opts + ')' : '') + ' is in your bag. We\'ll start sewing once you check out.');
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        })
        .finally(function () {
          addBtn.classList.remove('is-loading');
          addBtn.removeAttribute('aria-busy');
        });
    });

    // Sticky mobile buy bar
    // Shows once the photos have scrolled away, and hides while the main Add to bag button is on screen.
    var sticky = document.querySelector('[data-sticky-buy]');
    var stickyGallery = root.querySelector('[data-gallery]');
    if (sticky && 'IntersectionObserver' in window) {
      var pastGallery = false, addInView = false;
      var updateSticky = function () {
        var show = pastGallery && !addInView;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelector('button').tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (entries) {
        addInView = entries[0].isIntersecting;
        updateSticky();
      }).observe(addBtn);
      if (stickyGallery) {
        new IntersectionObserver(function (entries) {
          pastGallery = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          updateSticky();
        }).observe(stickyGallery);
      } else {
        pastGallery = true;
      }
      sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
        form.requestSubmit ? form.requestSubmit() : addBtn.click();
      });
    }

    // Gallery: dots on mobile, lightbox on desktop
    var gallery = root.querySelector('[data-gallery]');
    var counter = root.querySelector('[data-gallery-current]');
    if (gallery && counter) {
      gallery.addEventListener('scroll', function () {
        counter.textContent = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
      }, { passive: true });
    }
    var lightbox = document.querySelector('[data-lightbox]');
    if (gallery && lightbox) {
      gallery.addEventListener('click', function (e) {
        var item = e.target.closest('[data-gallery-index]');
        if (!item || window.matchMedia('(max-width: 899px)').matches) return;
        lastFocus = item;
        lightbox.classList.add('is-open');
        document.body.classList.add('has-drawer');
        var target = lightbox.querySelector('[data-lightbox-index="' + item.getAttribute('data-gallery-index') + '"]');
        if (target) target.scrollIntoView();
        lightbox.querySelector('[data-lightbox-close]').focus();
      });
      lightbox.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-close]') || e.target === lightbox) closeLightbox(lightbox);
      });
    }
  }
  /* ---------- Applying a size to the product form ---------- */
  function pick(fs, value) {
    if (!fs || !value) return false;
    var input = Array.prototype.find.call(fs.querySelectorAll('input[type=radio]'), function (i) { return i.value.toLowerCase() === String(value).toLowerCase(); });
    if (!input) return false;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  function applySize(size) {
    var form = document.getElementById('ProductForm');
    if (!form || !size) return false;
    var applied = false;
    form.querySelectorAll('fieldset[data-option-name]').forEach(function (fs) {
      var n = fs.getAttribute('data-option-name').toLowerCase();
      if (n.indexOf('cup') > -1) applied = pick(fs, size.cup) || applied;
      else if (n.indexOf('underbust') > -1 || n.indexOf('band') > -1) applied = pick(fs, size.band) || applied;
      else if (n.indexOf('size') > -1) applied = pick(fs, size.briefs) || applied;
    });
    applied = pick(form.querySelector('[data-band-property]'), size.band) || applied;
    return applied;
  }
  function productWants() {
    var form = document.getElementById('ProductForm');
    if (!form) return null;
    var names = Array.prototype.map.call(form.querySelectorAll('fieldset[data-option-name]'), function (f) { return f.getAttribute('data-option-name').toLowerCase(); }).join('|');
    if (names.indexOf('cup') > -1) return 'bra';
    if (names.indexOf('size') > -1) return 'briefs';
    return null;
  }
  function readSaved() { try { return JSON.parse(localStorage.getItem('valerie-size') || 'null') || {}; } catch (e) { return {}; } }
  function writeSaved(obj) { try { localStorage.setItem('valerie-size', JSON.stringify(Object.assign(readSaved(), obj))); } catch (e) {} }
  function savedLabel(saved, kind) {
    if (kind === 'bra' && saved.band && saved.cup) return saved.band + ' ' + saved.cup;
    if (kind === 'briefs' && saved.briefs) return 'size ' + saved.briefs;
    return null;
  }
  // Returning shoppers: their saved size is picked for them, so Add to bag is one tap.
  function initSavedSize() {
    var note = document.querySelector('[data-saved-size]');
    var kind = productWants();
    if (!note || !kind) return;
    if (new URL(window.location.href).searchParams.get('variant')) return;
    var saved = readSaved();
    var label = savedLabel(saved, kind);
    if (!label) return;
    if (!applySize(kind === 'bra' ? { band: saved.band, cup: saved.cup } : { briefs: saved.briefs })) return;
    note.innerHTML = '';
    note.appendChild(document.createTextNode('Your size (' + label + ') is selected. '));
    var change = document.createElement('button');
    change.type = 'button'; change.className = 'link'; change.textContent = 'Change';
    change.setAttribute('data-drawer-open', 'SizeGuide');
    note.appendChild(change);
    note.hidden = false;
  }

  /* ---------- Size calculator (Valerie's chart) ---------- */
  var CUPS = ['A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J', 'JJ'];
  function braSize(underbustIn, bustIn) {
    var bandIn = Math.round(underbustIn);
    if (bandIn % 2) bandIn += 1;                 // odd numbers round up to the next even
    var band = bandIn - 20;                      // 26" = 6 ... 50" = 30
    var diff = Math.round(bustIn) - bandIn;
    if (diff < 0) return { error: 'Your bust measurement looks smaller than your underbust. Could you double check both?' };
    if (band < 6 || band > 30 || diff > 14) return { custom: true, band: band, cup: diff > 14 ? null : CUPS[Math.max(diff, 1) - 1] };
    return { band: band, cup: CUPS[Math.max(diff, 1) - 1] };
  }
  function an(n) { return (String(n) === '8' || String(n) === '18' || String(n) === '11') ? 'an ' + n : 'a ' + n; }
  function briefsSize(hipCm, waistCm) {
    var sizes = [], i;
    for (i = 0; i <= 12; i++) sizes.push({ size: 6 + i * 2, waist: 61 + i * 5, hip: 86 + i * 5 });
    // Between two sizes? Size down, because the fabric stretches over time. Returns the looser option too.
    function by(key, v) {
      if (!v) return null;
      if (v > sizes[sizes.length - 1][key]) return { size: 'custom' };
      if (v <= sizes[0][key]) return { size: sizes[0].size };
      for (var j = sizes.length - 1; j >= 0; j--) {
        if (v >= sizes[j][key]) return { size: sizes[j].size, looser: v > sizes[j][key] && sizes[j + 1] ? sizes[j + 1].size : null };
      }
    }
    var h = by('hip', hipCm), w = by('waist', waistCm);
    return { briefs: h.size, looser: h.looser, waistSize: w ? w.size : null };
  }

  function initCalculators() {
    document.querySelectorAll('[data-size-calc]').forEach(function (calc) {
      var tabs = calc.querySelectorAll('[data-calc-tab]');
      var forms = calc.querySelectorAll('[data-calc-form]');
      var result = calc.querySelector('[data-calc-result]');
      var sizeEl = calc.querySelector('[data-calc-size]');
      var noteEl = calc.querySelector('[data-calc-note]');
      var labelEl = calc.querySelector('[data-calc-result-label]');
      var applyBtn = calc.querySelector('[data-calc-apply]');
      var buyBlock = calc.querySelector('[data-calc-buy]');
      var addBtn = calc.querySelector('[data-calc-add]');
      var colourLine = calc.querySelector('[data-calc-colour]');
      var changeColour = calc.querySelector('[data-calc-change-colour]');
      var shop = calc.parentElement && calc.parentElement.querySelector('[data-calc-shop]');
      var current = null;

      function show(tab) {
        tabs.forEach(function (t) { var on = t.getAttribute('data-calc-tab') === tab; t.setAttribute('aria-selected', on); t.classList.toggle('is-active', on); t.tabIndex = on ? 0 : -1; });
        forms.forEach(function (f) { f.hidden = f.getAttribute('data-calc-form') !== tab; });
        result.hidden = true;
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-calc-tab')); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var other = Array.prototype.find.call(tabs, function (x) { return x !== t; });
          other.focus(); other.click();
        });
      });
      show(calc.getAttribute('data-default') || 'bra');

      function num(form, name) { var v = parseFloat((form.elements[name].value || '').replace(',', '.')); return isNaN(v) ? null : v; }
      function unit(form) { var u = form.querySelector('input[name=unit]:checked'); return u ? u.value : 'cm'; }
      calc.addEventListener('change', function (e) {
        if (e.target.name !== 'unit') return;
        var form = e.target.form;
        form.querySelectorAll('[data-ph-' + e.target.value + ']').forEach(function (input) {
          input.placeholder = input.getAttribute('data-ph-' + e.target.value);
        });
      });

      function render(main, note, size, label) {
        labelEl.textContent = label || 'Your Valerie size';
        sizeEl.textContent = main;
        noteEl.textContent = note || '';
        result.hidden = false;
        current = size;
        var kindNow = calc.querySelector('[data-calc-form]:not([hidden])').getAttribute('data-calc-form');
        var canApply = !!size && !!buyBlock && productWants() === kindNow;
        if (buyBlock) {
          buyBlock.hidden = !canApply;
          if (canApply) {
            var colourFs = document.querySelector('#ProductForm .option--swatch');
            var colour = colourFs && colourFs.querySelector('input:checked');
            colourLine.parentElement.hidden = !colourFs;
            colourLine.textContent = colour ? colour.value : 'pick one';
            addBtn.textContent = 'Add to bag in ' + main;
          }
        }
        if (shop) shop.hidden = !size;
        // Bring the result and its Add to bag button into view straight away
        setTimeout(function () { (canApply ? buyBlock : result).scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 50);
      }

      forms.forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var kind = form.getAttribute('data-calc-form');
          var toIn = unit(form) === 'cm' ? 1 / 2.54 : 1;
          var toCm = unit(form) === 'in' ? 2.54 : 1;
          if (kind === 'bra') {
            var ub = num(form, 'underbust'), bust = num(form, 'bust');
            if (!ub || !bust) { render('', 'Pop in both measurements and we\'ll work it out.', null, 'Almost there'); return; }
            var r = braSize(ub * toIn, bust * toIn);
            if (r.error) { render('', r.error, null, 'Hmm, check that'); return; }
            if (r.custom) { render('Made for you', 'You\'re outside our standard chart, which is no problem because everything is made to order. Send us your measurements and we\'ll make it work.', null, 'Custom fit'); return; }
            writeSaved({ band: String(r.band), cup: r.cup });
            render(r.band + ' ' + r.cup, 'Band ' + r.band + ', cup ' + r.cup + '. Our cotton gives a little over time, so if you\'re ever between sizes, size down unless you want a looser fit.', { band: String(r.band), cup: r.cup });
          } else {
            var hip = num(form, 'hips'), waist = num(form, 'waist');
            if (!hip || !waist) { render('', 'Pop in both measurements and we\'ll work it out.', null, 'Almost there'); return; }
            var b = briefsSize(hip * toCm, waist * toCm);
            if (b.briefs === 'custom') { render('Made for you', 'You\'re outside our standard chart, which is no problem because everything is made to order. Send us your measurements and we\'ll make it work.', null, 'Custom fit'); return; }
            var note = 'Based on your hips, which matter most for briefs.';
            if (b.looser) note += ' You\'re between ' + an(b.briefs) + ' and ' + an(b.looser) + '. We\'ve gone with the ' + b.briefs + ' because our cotton gives a little over time. Want a looser fit? Choose the ' + b.looser + '.';
            if (b.waistSize && b.waistSize !== 'custom' && b.waistSize > b.briefs) note += ' Your waist points to ' + an(b.waistSize) + ', so for high waist styles like Poppy you might prefer the ' + b.waistSize + '.';
            if (b.waistSize === 'custom') note += ' Your waist is outside our chart, so message us and we\'ll tailor it.';
            writeSaved({ briefs: String(b.briefs) });
            render('Size ' + b.briefs, note, { briefs: String(b.briefs) });
          }
        });
      });

      function closeCalcDrawer() { var drawer = calc.closest('.drawer'); if (drawer) closeDrawer(drawer); }
      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          if (!applySize(current)) return;
          closeCalcDrawer();
          var buy = document.querySelector('[data-add-button]');
          if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
          toast(sizeEl.textContent + ' is selected.');
        });
      }
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (!applySize(current)) return;
          closeCalcDrawer();
          var form = document.getElementById('ProductForm');
          if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[data-add-button]').click();
        });
      }
      if (changeColour) {
        changeColour.addEventListener('click', function () {
          applySize(current);
          closeCalcDrawer();
          var fs = document.querySelector('#ProductForm .option--swatch');
          if (fs) fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  }

  function closeLightbox(lb) {
    lb.classList.remove('is-open');
    document.body.classList.remove('has-drawer');
    if (lastFocus) lastFocus.focus();
  }

  /* ---------- Collection filters and sort ---------- */
  function initCollection() {
    document.querySelectorAll('[data-facets-form]').forEach(function (form) {
      var isDesktop = !!form.closest('.facets--desktop');
      form.addEventListener('change', function (e) {
        if (isDesktop && e.target.matches('[data-auto-submit]')) form.submit();
      });
      if (isDesktop) {
        form.querySelectorAll('input[type="number"]').forEach(function (input) {
          input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); form.submit(); } });
          input.addEventListener('blur', function () { if (input.value !== input.defaultValue) form.submit(); });
        });
      }
    });
    var sort = document.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }

  /* ---------- Free shipping progress (same rules as everywhere else) ---------- */
  function initShipBar() {
    var bar = document.querySelector('[data-ship-bar]');
    var rules = cfg.freeShipping;
    if (!bar || !rules) return;
    var active = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'NZD';
    var threshold = 0, suffix = '';
    if (rules.country === 'NZ' && active === 'NZD') threshold = rules.nz * 100;
    if (rules.country === 'AU' && active === 'AUD') { threshold = rules.au * 100; suffix = ' AUD'; }
    var total = parseInt(bar.getAttribute('data-total'), 10) || 0;
    var count = parseInt(bar.getAttribute('data-count'), 10) || 0;
    var pieces = rules.pieces || 0;
    var text = bar.querySelector('[data-ship-text]');
    var fill = bar.querySelector('[data-ship-fill]');
    var track = bar.querySelector('[role=progressbar]');
    var pct;
    if ((pieces && count >= pieces) || (threshold && total >= threshold)) {
      text.textContent = 'Your order ships free';
      pct = 100;
    } else if (threshold) {
      var more = pieces ? pieces - count : 0;
      text.textContent = 'You\'re ' + formatMoney(threshold - total) + suffix + ' away from free shipping' + (more ? ', or add ' + more + ' more ' + (more === 1 ? 'piece' : 'pieces') : '');
      pct = Math.min(100, Math.round(total / threshold * 100));
    } else if (pieces) {
      var left = pieces - count;
      text.textContent = 'Add ' + left + ' more ' + (left === 1 ? 'piece' : 'pieces') + ' for free shipping';
      pct = Math.round(count / pieces * 100);
    } else { bar.hidden = true; return; }
    fill.style.width = pct + '%';
    track.setAttribute('aria-valuenow', pct);
  }

  /* ---------- Cart quantity ---------- */
  function initCart() {
    var form = document.getElementById('CartForm');
    if (!form) return;
    var timer;
    form.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (!step) return;
      var input = step.parentElement.querySelector('[data-qty-input]');
      input.value = Math.max(0, parseInt(input.value || '0', 10) + parseInt(step.getAttribute('data-qty-step'), 10));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      clearTimeout(timer);
      // Submitting with name=update keeps totals, discounts and shipping bar correct on the server
      timer = setTimeout(function () {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
        form.appendChild(hidden);
        form.submit();
      }, 450);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var product = document.querySelector('[data-product]');
    if (product) initProduct(product);
    initCollection();
    initCart();
    initCalculators();
    initSavedSize();
    initShipBar();
  });
})();
